export default "__VITE_ASSET__53260457__"